module.exports = __webpack_public_path__ + "img/i.75dd27a3.jpg";